export default `
  fragment ColorFillElement on BoothDesignColorFillElement {
    maskImage {
      ...CommonLocalizableImage
    }
    fillColor
    name: keyName
  } 
`;
